import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';

export interface BearerState {
  bearer: string | null;
}

export function createInitialBearer(): BearerState {
  const bearer = localStorage.getItem('AuthorizationBearer');
  const bearerStore = !!bearer ? bearer : 'DocoutBearer ';
  return { bearer: bearerStore };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'bearer' })
export class BearerStore extends Store<BearerState> {

  constructor() {
    super(createInitialBearer());
  }

  setBearer(bearer: string) {
    localStorage.setItem('AuthorizationBearer', bearer);
    this.update({ bearer });
  }

  resetBearer() {
    localStorage.setItem('AuthorizationBearer', 'DocoutBearer ');
    this.update(createInitialBearer());
  }

}
